export default __webpack_public_path__ + "static/media/screen5.62efda38.png";